import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../../shared/snack-bar/components/snack-bar.component';

export interface SnackBarData {
  type: string;
  message: string;
  closeButton?: boolean;
}

@Injectable({ providedIn: 'root' })
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) {}

  open(
    data: SnackBarData = {
      type: 'info',
      message: 'teste message',
    },
    config: MatSnackBarConfig = {
      duration: 0,
    }
  ) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      panelClass: 'custom-snack-bar',
      horizontalPosition: 'center',
      verticalPosition: 'top',
      ...config,
      data,
    });
  }

  dismiss() {
    this.snackBar.dismiss();
  }
}
